import React from "react";
import styled from "styled-components";
import { Body2 } from "app/popleads/components/ui-kit/Text";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { Heading4 } from "app/popleads/components/ui-kit/Text";
import { colors } from "app/popleads/components/ui-kit/colors";
import { useExtensionContext } from "../ExtensionContext";

const StyledTitle = styled(Heading4)`
    margin-bottom: 18px;
    color: ${colors.neutral[700]};
    display: block;
`;

const StyledItemContainer = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

const StyledContentText = styled(Body2)`
    color: ${colors.l3rnTech[900]};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 70%;
`;

const ExtensionActivities = () => {
    const { selectedDeal } = useExtensionContext();

    const availableActivities = [
        { id: 1, activityName: "Invoice Requisiton", type: "invoice" },
        { id: 2, activityName: "Proposal", type: "proposal" },
        { id: 3, activityName: "Course Campaign", type: "campaign" },
    ].filter((activity) => {
        switch (activity.type) {
            case "invoice":
                return !!selectedDeal?.invoiceRequisitionActivityId;
            case "proposal":
                return !!selectedDeal?.activityId;
            case "campaign":
                return !!selectedDeal?.inHouseId;
            default:
                return false;
        }
    });

    if (availableActivities.length === 0) return null;

    return (
        <>
            <StyledTitle>Activities</StyledTitle>
            {availableActivities.map((activity, index) => (
                <StyledItemContainer key={index}>
                    <StyledContentText>{activity.activityName}</StyledContentText>
                    <div>
                        <ButtonWithText
                            icon="external-link"
                            iconType="feather"
                            variant="l3rnTech"
                            size="circle"
                            buttonStyle="default"
                            onClick={() => {
                                const baseUrl = "/activities?activityId=";
                                let redirectId;

                                switch (activity.type) {
                                    case "invoice":
                                        redirectId = selectedDeal?.invoiceRequisitionActivityId;
                                        break;
                                    case "proposal":
                                        redirectId = selectedDeal?.activityId;
                                        break;
                                    case "campaign":
                                        redirectId = selectedDeal?.inHouseId;
                                        break;
                                    default:
                                        redirectId = "";
                                }

                                if (redirectId) {
                                    window.open(baseUrl + redirectId, "_blank");
                                }
                            }}
                        />
                    </div>
                </StyledItemContainer>
            ))}
        </>
    );
};

export default ExtensionActivities;
